import {
  Button,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  Card,
} from '@mui/material'
import { updateVendorList, getUpdateVendorList } from 'api/user'
import { useAlert } from 'hooks/useDialog'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { useVendorListConfigLoader } from './VendorListConfig.loader'

const VendorListConfig = () => {
  const UPDATING_STATUS = '更新中'
  const navigate = useNavigate()
  const [isPending, setIsPending] = useState(false)

  const vendorListStatus = useVendorListConfigLoader()

  const vendorListUpdateStartTime = vendorListStatus.startTime
  const vendorListUpdateTime = vendorListStatus.updateTime
  const vendorListUpdateStatus = vendorListStatus.updateStatus

  const alert = useAlert()

  const handleUpdateVendorList = async (isPost?: boolean) => {
    const WT = 1000 * 2
    setIsPending(true)
    try {
      if (isPost) {
        // const { startTime, updateTime, updateStatus } = await updateVendorList()
        await updateVendorList()
        // wait a little time
        await new Promise((resolve) => setTimeout(resolve, WT))
      }
      // const { startTime, updateTime, updateStatus } = await getUpdateVendorList()
      const { updateStatus } = await getUpdateVendorList()

      if (updateStatus === UPDATING_STATUS) {
        alert({ message: '更新中です' })
      } else {
        alert({ message: '更新が完了しました' })
      }
    } catch (err) {
      alert({ message: '更新に失敗しました' })
    }
    setIsPending(false)
    navigate('.')
  }

  const updating = vendorListUpdateStatus === UPDATING_STATUS

  return (
    <Card variant="outlined">
      <TableContainer>
        <Table style={{ tableLayout: 'fixed' }}>
          <TableHead data-testid="table-head-concur">
            <TableRow>
              <TableCell component="th">最終更新日時</TableCell>
              <TableCell component="th">ステータス</TableCell>
              <TableCell component="th" />
            </TableRow>
          </TableHead>
          <TableBody data-testid="table-body-concur">
            <TableRow>
              <TableCell>{vendorListUpdateTime}</TableCell>
              <TableCell>
                {updating
                  ? `${vendorListUpdateStatus} (started: ${vendorListUpdateStartTime})`
                  : vendorListUpdateStatus}
              </TableCell>
              <TableCell align="right">
                {!updating ? (
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => handleUpdateVendorList(true)}
                    disabled={isPending}
                    data-testid="update-button"
                  >
                    更新
                  </Button>
                ) : (
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => handleUpdateVendorList(false)}
                    disabled={isPending}
                    data-testid="recheck-update-status-button"
                  >
                    更新状態再確認
                  </Button>
                )}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Card>
  )
}

export default VendorListConfig
